import React from 'react';

interface MetricIconProps {
  iconName: 'total-patient' | 'active-monitoring' | 'criticak-alert' | 'total-clinic';
  size?: number;
  className?: string;
}

const iconMap = {
  'total-patient': 'total-patient',
  'active-monitoring': 'active-monitoring',
  'criticak-alert': 'criticak-alert',
  'total-clinic': 'total-clinic'
} as const;

export const MetricIcon: React.FC<MetricIconProps> = ({
  iconName,
  size = 40,
  className = ''
}) => {
  const iconId = iconMap[iconName] || 'total-clinic';
  
  return (
    <div className={className}>
      <svg width={size} height={size} viewBox="0 0 44 44">
        <use xlinkHref={`/assets/sprite.svg#${iconId}`} />
      </svg>
    </div>
  );
};

export default MetricIcon;
